import { render, staticRenderFns } from "./VInputRadio.vue?vue&type=template&id=24cd2427&scoped=true"
import script from "./VInputRadio.vue?vue&type=script&lang=js"
export * from "./VInputRadio.vue?vue&type=script&lang=js"
import style0 from "./VInputRadio.vue?vue&type=style&index=0&id=24cd2427&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd2427",
  null
  
)

export default component.exports